// src/database/providerSync.js

import {
  fetchAllNebraskaProviders,
  saveProviders,
  getAllProviders,
} from "./providerDirectory";

const SYNC_KEY = "providerDirectoryLastSync";
const SYNC_DAYS = 31;

function isFreshEnough() {
  const lastSync = localStorage.getItem(SYNC_KEY);
  if (!lastSync) return false;

  const last = new Date(lastSync).getTime();
  const now = Date.now();
  const diffDays = (now - last) / (1000 * 60 * 60 * 24);

  return diffDays < SYNC_DAYS;
}

export async function ensureProvidersSynced() {
  try {
    // If data is already fresh, do nothing
    const existing = await getAllProviders();
    if (existing.length > 0 && isFreshEnough()) {
      console.log("Provider directory is already fresh, skipping sync.");
      return;
    }

    // If offline, skip fetch and just keep what we have
    if (typeof navigator !== "undefined" && navigator && navigator.onLine === false) {
      console.warn("Offline, skipping provider sync; using cached providers.");
      return;
    }

    console.log("Fetching providers from NPI API...");

    const providers = await fetchAllNebraskaProviders();
    await saveProviders(providers);

    localStorage.setItem(SYNC_KEY, new Date().toISOString());
    console.log(`Saved ${providers.length} providers to IndexedDB.`);
  } catch (err) {
    // Do not rethrow, so callers can still use cached data
    console.error("Error syncing provider directory (using cached data if any):", err);
  }
}
